import {
  selectEmail,
  selectTeam,
} from "@/features/calendar/calendarFilter/appointmentFilterSelector";
import { hasItems } from "@repo/utils";
import { useMemo } from "react";

import { type CalenderAppointmentsSearchFilters } from "../calendarFilter/appointmentFilterReducer";

interface AppointmentSearchParam {
  selectedDate?: string;
  teamId?: string;
  emailId?: string;
  tableView?: string;
}

export const useMakeUrlParams = (
  appointmentFilters: CalenderAppointmentsSearchFilters
) => {
  return useMemo(() => {
    const params = {} as AppointmentSearchParam;
    const selectedTeam = selectTeam(appointmentFilters);
    const selectedEmails = selectEmail(appointmentFilters);

    if (appointmentFilters?.selectedDate) {
      params.selectedDate = String(appointmentFilters?.selectedDate.getTime());
    }
    if (selectedTeam) {
      params.teamId = String(selectedTeam);
    }
    if (appointmentFilters.tableView) {
      params.tableView = appointmentFilters.tableView;
    }
    if (hasItems(selectedEmails)) {
      params.emailId = selectedEmails.join(",");
    }
    return params;
  }, [appointmentFilters]);
};
